import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-text-dark text-cream" data-id="element-68">
      <div className="max-w-3xl mx-auto" data-id="element-69">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-70">
          <h2 className="text-3xl sm:text-4xl font-bold font-heading text-gold mb-6" data-id="element-71">
            ¿Por qué sigues gritando si sabes que está mal?
          </h2>
          <div className="h-px w-24 bg-gold-dark mx-auto" data-id="element-72"></div>
        </motion.div>

        <div className="space-y-8 text-lg sm:text-xl leading-[1.8] text-cream-secondary/90" data-id="element-73">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} data-id="element-74">
            El problema no es que seas una{' '}
            <span className="text-gold font-heading italic" data-id="element-75">"mala madre"</span>.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-76">
            El problema es que te han enseñado que la crianza es una cuestión de
            "voluntad" y "paciencia". Pero la paciencia es un recurso biológico
            que se agota.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="p-6 bg-accent-deep/50 border border-gold/20 rounded-lg" data-id="element-77">
            Cuando tu sistema nervioso está al límite,{' '}
            <span className="text-gold font-medium" data-id="element-78">
              tu cerebro lógico se apaga y tu cerebro reptiliano toma el control
            </span>
            . Es pura supervivencia biológica.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} data-id="element-79">
            Has intentado leer libros de psicología positiva que parecen
            escritos para monjes budistas, no para madres latinas con vidas
            reales, poco sueño y mucha presión.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} className="text-2xl font-heading text-gold text-center pt-4" data-id="element-80">
            Por eso fallas. Y por eso necesitas un sistema, no más culpa.
          </motion.p>
        </div>
      </div>
    </section>;
}